import { useState } from 'react';

/**
 * An entry of a list opened on its own screen, for lists with no "fetch one"
 * on the server (the Items Manager's): the row it was opened from, kept fresh
 * from the list while the list still holds it.
 */
export function useOpenRecord<T extends { id: string }>(rows: readonly T[]) {
  const [opened, setOpened] = useState<T | null>(null);
  return {
    row: opened ? (rows.find((r) => r.id === opened.id) ?? opened) : null,
    open: (row: T) => setOpened(row),
    close: () => setOpened(null),
    /**
     * Keeps the page on an entry the list has stopped showing, as it now is:
     * one switched off while "Show deleted" is off is still there, deleted.
     */
    patch: (change: Partial<T>) => setOpened((r) => (r ? { ...r, ...change } : r)),
  };
}
